import "./Sidebar.scss";

import { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";

import type { SidebarNavItem } from "../../../../types/config/navConfig";
import { AriaLabel } from "../../../../types/enums/ariaLabels";
import { Button } from "../../../shared";
import { sidebarIconMap } from "./icons";

interface SidebarProps {
  items: readonly SidebarNavItem[];
  isLoading?: boolean;
}

export function Sidebar({ items, isLoading = false }: SidebarProps) {
  const [collapsed, setCollapsed] = useState(false);

  if (!isLoading && items.length === 0) return null;

  return (
    <aside
      className={`app-sidebar ${collapsed ? "app-sidebar--collapsed" : ""}`}
      aria-label={AriaLabel.SecondaryNav}
    >
      <nav className="app-sidebar__nav">
        <ul className="app-sidebar__list">
          {items.map(({ to, label, iconKey }) => {
            const IconComponent = sidebarIconMap[iconKey];
            return (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `app-sidebar__item ${isActive ? "app-sidebar__item--active" : ""}`
                  }
                >
                  <span className="app-sidebar__icon" aria-hidden>
                    <IconComponent />
                  </span>
                  {!collapsed && <span className="app-sidebar__label">{label}</span>}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
      {items.length > 0 ? (
        <Button
          variant="ghost"
          type="button"
          className="app-sidebar__collapse focus-ring"
          onClick={() => setCollapsed((c) => !c)}
          aria-label={collapsed ? AriaLabel.ExpandSidebar : AriaLabel.CollapseSidebar}
          title={collapsed ? AriaLabel.ExpandSidebar : AriaLabel.CollapseSidebar}
        >
          <span aria-hidden>{collapsed ? <FaChevronRight /> : <FaChevronLeft />}</span>
        </Button>
      ) : null}
    </aside>
  );
}
